import api from './api';

export const authService = {
  async login(email, password) {
    const response = await api.post('/login', { email, password });
    if (response.data.token) {
      console.log('💾 [AuthService] Guardando token en localStorage');
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      console.log('✅ [AuthService] Token guardado exitosamente');
      console.log('🔑 [AuthService] Token (primeros 20 caracteres):', response.data.token.substring(0, 20) + '...');
    } else {
      console.warn('⚠️ [AuthService] No se recibió token en la respuesta');
    }
    return response.data;
  },

  async logout() {
    try {
      await api.post('/logout');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  },

  async getUser() {
    const response = await api.get('/user');
    return response.data;
  },

  isAuthenticated() {
    return !!localStorage.getItem('token');
  },

  getCurrentUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  /** Actualiza el usuario en localStorage desde GET /user (almacenes y módulos). */
  async syncUserFromApi() {
    const response = await api.get('/user');
    const data = response.data;
    const current = this.getCurrentUser() || {};
    const merged = { ...current, ...data };
    localStorage.setItem('user', JSON.stringify(merged));
    return merged;
  },
};
